import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useLinkChecker } from "@app/hooks/linkChecker";
import { usePresignURL } from "@app/hooks/s3";

export const FileType = ({ url, filePath }) => {
  const [fileType, setFileType] = useState("–");

  const urlQuery = usePresignURL(filePath, {
    enabled: !url && !!filePath,
    staleTime: 60 * 60 * 1000,
  });
  const urlToCheck = urlQuery.data?.presignURL || url;
  const linkChecker = useLinkChecker(urlToCheck, {
    enabled: !!urlToCheck && !urlToCheck.startsWith("data:"),
  });

  useEffect(() => {
    if (linkChecker.isSuccess) {
      let type;

      switch (linkChecker.data.contentType) {
        case "image/jpeg":
        case "image/jpg":
          type = "JPG";
          break;
        case "image/png":
          type = "PNG";
          break;
        case "image/gif":
          type = "GIF";
          break;
        case "image/webp":
          type = "WEBP";
          break;
        case "image/svg+xml":
          type = "SVG";
          break;
        case "video/mp4":
          type = "MP4";
          break;
        case "video/quicktime":
          type = "MOV";
          break;
        default:
          type = "–";
      }
      setFileType(type);
    }
  }, [linkChecker.isSuccess]);

  return fileType;
};

FileType.propTypes = {
  url: PropTypes.string,
  filePath: PropTypes.string,
};
